import PropTypes from "prop-types";
import React from "react";
import ThemeBadge from "theme/components/badges/ThemeBadge";
import styled from "theme/libs/styled";

const Wrapper = styled("div")`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px;
`;

const Flags = ({ badgeTheme, flags, textStyles }) => {
    const cleanFlags = flags.map((flag) => ({
        text: flag.flag_name_overwrite || flag.flag?.name || flag.name || flag.text || flag,
        badgeTheme: flag.badge_theme || "",
    }));

    return (
        <Wrapper>
            {cleanFlags.map((flag) => (
                <ThemeBadge
                    key={flag.name}
                    badgeTheme={flag.badgeTheme || badgeTheme}
                    text={flag.text}
                    textStyle={textStyles}
                />
            ))}
        </Wrapper>
    );
};

Flags.propTypes = {
    badgeTheme: PropTypes.string,
    flags: PropTypes.array.isRequired,
    textStyles: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
};

Flags.defaultProps = {
    badgeTheme: "grey",
    textStyles: ["Myriad Pro/12-100", null, null, null, "Myriad Pro/14-100"],
};

export default Flags;
